export default __webpack_public_path__ + "static/media/ButtonPressed.min.0253aa79.png";